import track from '~/mixpanel-service';
import { OnboardingStep } from './types';

const getTrackedEvent = (step: number, eventName: string, isOffboarding?: boolean): string => {
    const steps = {
        [OnboardingStep.Introduction]: 'introduction',
        [OnboardingStep.Subscription]: 'subscription',
        [OnboardingStep.InventoryPrinciple]: 'inventory-principle',
        [OnboardingStep.ConfirmInformation]: 'confirm-information',
        [OnboardingStep.ConfirmTransferData]: 'confirm-transfer-data',
        [OnboardingStep.TransferDataInProgress]: 'transfer-data-in-progress',
        [OnboardingStep.IntegrationCompleted]: 'integration-completed',
        [OnboardingStep.Offboarded]: 'init',
    };

    const currentStepName = steps[step] || '';
    const event = `${isOffboarding ? 'offboarding' : 'onboarding'}.${currentStepName}.${eventName}`;

    return event;
};

export const trackEvent = (currentStep: number, eventName: string, trackingData?: object, isOffboarding?: boolean) => {
    const newTrackedEvent = getTrackedEvent(currentStep, eventName, isOffboarding);
    track('rackbeat', newTrackedEvent, trackingData);
};
